'use client';
import React, { Dispatch, FC, SetStateAction, useRef } from 'react';

import CarRentalHomeSearchBarContent, { ICarSearchBarHandle } from './home';

interface ICarRentalSearch {
  page?: 'home' | 'list' | 'basket';
  alignVertical?: boolean;
  setIsRedirecting?: Dispatch<SetStateAction<boolean>>;
}

const CarRentalHomeSearchBar: FC<ICarRentalSearch> = ({
  page = 'home',
  alignVertical,
  setIsRedirecting,
}) => {
  const CarRentalSearchBarRef = useRef<ICarSearchBarHandle>(null);
  return (
    <CarRentalHomeSearchBarContent
      alignVertical={alignVertical}
      page={page}
      ref={CarRentalSearchBarRef}
      setIsRedirecting={setIsRedirecting}
    />
  );
};

export default CarRentalHomeSearchBar;
